module.exports = __webpack_public_path__ + "static/media/rosto-sorrindo.225592dd.svg";